import React from 'react';
import LocationTemplate from './LocationTemplate';

const PinkHillPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Pink Hill"
      stateName="North Carolina"
      countyName="Lenoir"
      zipCodes={["28572"]}
      latitude={35.0547}
      longitude={-77.7467}
      population={552}
      historicalFact="Incorporated in 1957, known for its annual Peony Festival."
      nearbyTowns={[
        "Kinston, NC",
        "La Grange, NC",
        "Trenton, NC",
        "Beulaville, NC",
        "Mount Olive, NC",
        "Calypso, NC",
        "Warsaw, NC",
        "Deep Run, NC"
      ]}
    />
  );
};

export default PinkHillPage;